import styled from 'styled-components'

export const WrapperCard = styled.div`
  .hold-cards {
    @media only screen and (min-width: 1199.9px) and (max-width: 1517px) {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-gap: 20px;
      > div {
        margin: 0;
      }
      margin-bottom: 20px;
    }
  }
`
